import {
  MedicationStockReason,
  MediaAttachment,
  AdministrationStatus
} from '../types'

export const getActionTitle = (
  reason: MedicationStockReason,
  t: (key: string) => string
): string => {
  switch (reason) {
    case MedicationStockReason.INITIAL_STOCK:
      return t('INITIAL_STOCK')
    case MedicationStockReason.STOCK_COUNT:
    case MedicationStockReason.RECONCILIATION:
      return t('STOCK_CHECK')
    case MedicationStockReason.DISPOSAL:
      return t('DISPOSAL')
    case MedicationStockReason.RESTOCK:
      return t('ADD_STOCK')
    case MedicationStockReason.MED_ADMIN:
      return t('ADMINISTERED')
    default:
      return reason.replace(/_/g, ' ')
  }
}

export const getActionSubtitle = (
  reason: MedicationStockReason,
  quantityChange: number,
  unit: string,
  notes?: string | string[],
  t?: (key: string) => string
): string | undefined => {
  switch (reason) {
    case MedicationStockReason.STOCK_COUNT:
    case MedicationStockReason.RECONCILIATION:
    case MedicationStockReason.INITIAL_STOCK:
      return undefined
    case MedicationStockReason.NOT_ADMINISTERED:
      if (Array.isArray(notes)) {
        return notes.join(', ')
      }
      return notes || ''
    case MedicationStockReason.DISPOSAL:
    case MedicationStockReason.RESTOCK:
    case MedicationStockReason.MED_ADMIN:
      const quantity = Math.abs(quantityChange || 0)
      return `${quantity} ${unit}`
    default:
      return undefined
  }
}

export const convertMediaAttachmentsToFileList = (
  mediaAttachments: MediaAttachment[],
  recordId: string
): any[] => {
  return mediaAttachments.map((attachment, i) => ({
    uid: attachment._id || `${recordId}-${i}`,
    name: attachment.key.split('/').pop() || `file-${i}`,
    status: 'done' as const,
    url: attachment.url,
    thumbUrl: attachment.url
  }))
}

/**
 * Maps administrationStatus to translation key for display
 */
export const getAdministrationStatusTranslationKey = (
  administrationStatus: AdministrationStatus | string
): string => {
  // Normalize to uppercase for comparison
  const status = String(administrationStatus).toUpperCase()

  switch (status) {
    case AdministrationStatus.GIVEN:
      return 'ADMINISTERED'
    case AdministrationStatus.REFUSED:
      return 'REFUSED'
    case AdministrationStatus.NOT_GIVEN:
      return 'NOT_ADMINISTERED'
    case AdministrationStatus.MISSED:
      return 'MISSED'
    case AdministrationStatus.PAUSED:
      return 'PAUSED'
    case AdministrationStatus.DISCONTINUED:
      return 'DISCONTINUED'
    case AdministrationStatus.NOT_SCHEDULED:
      return 'NOT_SCHEDULED_OR_NOT_NEEDED'
    default:
      // Default to ADMINISTERED if status is unknown
      return 'ADMINISTERED'
  }
}
